import { render, staticRenderFns } from "./common-problem-chinese.vue?vue&type=template&id=5fb5b504&scoped=true"
import script from "./common-problem-chinese.vue?vue&type=script&lang=js"
export * from "./common-problem-chinese.vue?vue&type=script&lang=js"
import style0 from "./common-problem-chinese.vue?vue&type=style&index=0&id=5fb5b504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5b504",
  null
  
)

export default component.exports